module.exports = __webpack_public_path__ + "img/31096af.png";